import { render, staticRenderFns } from "./AccessBtn.vue?vue&type=template&id=5a669c5c&scoped=true&"
import script from "./AccessBtn.vue?vue&type=script&lang=ts&"
export * from "./AccessBtn.vue?vue&type=script&lang=ts&"
import style0 from "./AccessBtn.vue?vue&type=style&index=0&id=5a669c5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a669c5c",
  null
  
)

export default component.exports